<script>
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => ({})
        },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            offset: true,
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                minRotation: 0,
                                callback: function(val, index) {
                                    return index % 4 === 0 ? val : '';
                                }
                            },
                            gridLines: {
                                display:false
                            },
                            type: 'time',
                            time: {
                                unit: 'day',
                                tooltipFormat: 'MMM. DD'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                autoSkip: true,
                                callback: function(val, index) {
                                    // Hide every 2nd tick label
                                    return index % 2 === 0 ? val : '';
                                }
                            }
                        }
                    ]
                },
                datasets: {
                    barThickness: 8
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label: ((tooltipItems, data) => {
                            let total = 0;
                            if (tooltipItems.datasetIndex === 1) {
                                data.datasets.map( (item) => {
                                    total += item.data[tooltipItems.index];
                                });
                            } else {
                                total = tooltipItems.value;
                            }
                            return data.datasets[tooltipItems.datasetIndex].label + ': ' + total;
                        })
                    }
                }
            })
        },
        data: {
            type: Array,
            default: () => ([])
        },
        chartLabel: {
            Type: String,
            default: "Label"
        },
        backgroundColorSales: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--chartColor')
        },
        backgroundColorDemand: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--chartColorDefault')
        },
        labelSales: {
            Type: String,
            default: "Sales"
        },
        labelDemand: {
            Type: String,
            default: "Demand"
        },
        width: {
            Type: Number,
            default: 200
        },
        height: {
            Type: Number,
            default: 200
        }
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            this.renderChart(
                {
                    labels: this.labels,
                    datasets: [
                        {
                            label: this.labelSales,
                            backgroundColor: this.backgroundColorSales,
                            data: this.data[0]
                        },
                        {
                            label: this.labelDemand,
                            backgroundColor: this.backgroundColorDemand,
                            data: this.data[1]
                        }
                    ]
                },
                this.options
            );
        }
    },
    watch: {
        data() {
            this.render();
        }
    }
};
</script>
